var map = {
	"./avatar-sammy-base-full.png": 80116,
	"./avatar-sammy-dino-full.png": 70281,
	"./avatar-sammy-fall-full.png": 75064,
	"./avatar-sammy-smoothie-full.png": 78965,
	"./avatar-sammy-space-full.png": 38571,
	"./avatar-sammy-spring-full.png": 60964,
	"./avatar-sammy-summer-full.png": 94764,
	"./avatar-sammy-winter-full.png": 56688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19713;